import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { api } from "../../lib/api"
import type { TentativaResumo } from "../../types"
import { dataCurta } from "../../lib/format"
import { Card, Carregando, Selo } from "../ui"

export default function Historico() {
  const [tentativas, setTentativas] = useState<TentativaResumo[] | null>(null)

  useEffect(() => {
    api.get<{ tentativas: TentativaResumo[] }>("/tentativas").then((r) => setTentativas(r.tentativas))
  }, [])

  if (!tentativas) return <Carregando />

  if (tentativas.length === 0) {
    return (
      <Card>
        <p className="text-center text-sm text-slate-600">
          Você ainda não concluiu nenhum simulado.{" "}
          <Link to="/painel" className="font-semibold text-navy-800 underline">
            Comece o primeiro
          </Link>
          .
        </p>
      </Card>
    )
  }

  return (
    <div className="space-y-3">
      <h1 className="text-xl font-bold text-navy-900">Histórico</h1>
      {tentativas.map((t) => (
        <Link key={t.id} to={`/simulado/${t.id}/resultado`} className="block">
          <Card className="transition hover:border-navy-300">
            <div className="flex items-center justify-between gap-4">
              <div>
                <p className="font-semibold text-navy-900">{t.prova}</p>
                <p className="text-xs text-slate-500">{dataCurta(t.finalizada_em)}</p>
              </div>
              <div className="flex items-center gap-3">
                <span className="font-bold text-navy-900">
                  {t.acertos}/{t.total}
                </span>
                <Selo tom={t.aprovada ? "ok" : "neutro"}>{t.aprovada ? "Passou" : "Não passou"}</Selo>
              </div>
            </div>
          </Card>
        </Link>
      ))}
    </div>
  )
}
